import amaLog from "../helpers/log";

const hostInfo = (): { isSeOcelot: boolean, siteName: string, isBlog: boolean, blogHost: string } => {
  let isBlog = false;
  let blogHost = '';
  let host: string = (typeof window !== 'undefined' ? window.ama?.hostName || window.location.hostname : '').toLowerCase();

  if (host.startsWith('www.')) {
    host = host.slice(4);
  }

  if (host === 'mabra.com') return { isSeOcelot: true, siteName: 'mabra', isBlog: false, blogHost: '' };

  const parts: string[] = host.split('.');

  if (parts.length >= 3) return { isSeOcelot: false, siteName: '', isBlog: true, blogHost: parts[1] };

  const [siteName, tld] = parts;

  return {
    isSeOcelot: (tld === 'se' && siteName !== 'recept'),
    siteName,
    isBlog,
    blogHost
  };
};
let amaModulesCache: any = null;
const adTagsSites = {
  motherhood: {},
  elle: {},
  residencemagazine: {},
  mabra: {},
  svenskdam: {},
  hant: {},
  femina: {}
};
export default function getModules() {
  if (amaModulesCache) return amaModulesCache;

  const { siteName, isSeOcelot, isBlog, blogHost } = hostInfo();
  const loadGptSites = ['motherhood'];
  const multivideoSites = ['allas'];
  const searchParamExist = window.location.search.includes('multivideo=1');
  const isMultivideoSite = multivideoSites.includes(siteName) || (isBlog && multivideoSites.includes(blogHost) && searchParamExist);
  const adTags = adTagsSites[siteName as keyof typeof adTagsSites] || null;
  const dmScript = isMultivideoSite ? 'https://ads.rubiconproject.com/prebid/13012_Allas_exp.28.js' : 'https://micro.rubiconproject.com/prebid/dynamic/13012.js';

  amaModulesCache = {
    prebidScript: dmScript,
    useStats: true,
    useVideoStats: true,
    useLimitedAds: true,
    useGrowthbook: true,
    useGLazyLoad: ['responsive_1', 'top_ad'],
    useDivModificationsOnMainCat: true,
    usePrebidVideo: true,
    useVerticals: isSeOcelot,
    useSecondArticle: isSeOcelot,
    useLoadDMByAdsLib: true,
    usePlacementCheck: isSeOcelot,
    useLoadGptByAdsLib: loadGptSites.includes(siteName),
    useLoadTopad: isSeOcelot,
    useRequestMultiVideoBids: isMultivideoSite,
  };
  if (adTags) {
    amaModulesCache.adTags = adTags;
  }
  return amaModulesCache;
}
